import { type LucideIcon } from 'lucide-react';

interface ServiceIconProps {
  icon: LucideIcon;
  active: boolean;
  title?: string;
  size?: 'sm' | 'md' | 'lg';
}

export function ServiceIcon({ icon: Icon, active, title, size = 'md' }: ServiceIconProps) {
  const sizeClasses = size === 'sm' ? 'p-1' : size === 'lg' ? 'p-2' : 'p-1.5';
  const iconSize = size === 'sm' ? 14 : size === 'lg' ? 20 : 16;

  return (
    <div
      className={`${sizeClasses} rounded transition-colors tooltip-delay ${
        active ? 'text-indigo-600 bg-indigo-50' : 'text-slate-300'
      }`}
      data-tooltip={title}
    >
      <Icon size={iconSize} strokeWidth={1.5} />
    </div>
  );
}

// Common service icon presets for convenience
export { Phone, Shield, User, MessageSquare, Printer, PhoneForwarded, Settings } from 'lucide-react';
